import type { OfferTicket as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type OfferTicket = {
  id: number;
  gross: number;
  name: string;
  price: number;
  projected: number;
  section?: string;
};

export const fromGql = (item: GQLItem): OfferTicket =>
  take<OfferTicket, GQLItem>(item, 'id', 'gross', 'name', 'price', 'projected', 'section');
